import * as Yup from 'yup';

/**
 * Sign-in validation.
 *
 * Kept in its own module so the rules can be tested without rendering a form.
 *
 * DELIBERATELY MINIMAL. It only catches what is obviously unusable — an empty
 * box — and leaves everything else to the server.
 *
 * In particular there is NO password length or complexity rule. Credentials here
 * come from environment variables, set by hand; inventing a "minimum 8
 * characters" here would lock out a real account whose password is shorter,
 * with an error that blames the user for something they cannot see or change.
 * Client-side validation is there to save a round trip, not to re-decide who is
 * allowed in.
 */
export const loginSchema = Yup.object({
  username: Yup.string()
    .trim()
    .required('Enter your username'),
  password: Yup.string()
    .required('Enter your password'),
});

export const loginInitialValues = { username: '', password: '' };
